import { render, staticRenderFns } from "./myhead.vue?vue&type=template&id=6c99ecf0&scoped=true&"
import script from "./myhead.vue?vue&type=script&lang=js&"
export * from "./myhead.vue?vue&type=script&lang=js&"
import style0 from "./myhead.vue?vue&type=style&index=0&id=6c99ecf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99ecf0",
  null
  
)

export default component.exports